import { Button } from '@/view/components/ui/button'
import { Dialog, DialogClose, DialogContent } from '@/view/components/ui/dialog'

interface ConfirmProposalModalProps {
  open: boolean
  onClose: () => void
  onConfirm: () => void
  isLoading?: boolean
}

export default function ConfirmProposalModal({
  open,
  onClose,
  onConfirm,
  isLoading = false,
}: ConfirmProposalModalProps) {
  const handleConfirm = () => {
    if (isLoading) return
    onConfirm()
    onClose()
  }

  return (
    <Dialog open={open} onOpenChange={onClose}>
      <DialogContent className="max-h-[320px] overflow-y-auto p-6 sm:max-w-md">
        <div className="mt-6 flex flex-col items-start gap-1.5 px-6">
          <strong className="font-semibold">
            Já existe uma transação em andamento para este cliente
          </strong>
          <p className="text-sm font-medium text-black04">
            Deseja continuar com a nova transação?
          </p>
        </div>
        <div className="mt-6 flex flex-row gap-2">
          <Button
            variant="outline"
            className="flex-1 rounded-full text-primary"
            onClick={onClose}
            disabled={isLoading}
          >
            Cancelar
          </Button>
          <DialogClose asChild>
            <Button
              className="flex-1 rounded-full font-semibold text-white"
              onClick={handleConfirm}
              isLoading={isLoading}
            >
              Confirmar
            </Button>
          </DialogClose>
        </div>
      </DialogContent>
    </Dialog>
  )
}
